import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterSecComp from '../FooterSecComp'
import FooterComp from '../FooterComp'
import { Typography } from '@mui/material'
import career from '../../../Assets/img/Careers.png'

const WorkWithUs = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    const section1 = ['If you want to see a better world and really want to do something about it yourself, read further!']

    const section2 = [
        'We are a 15-year-old not-for-profit organisation based out of Mumbai, India. There has never been a dull moment in the past 15 years, there’s always more to do: new projects, new partners and collaborations, new tools and apps to learn and adapt, new themes, cultures, languages to assimilate, new challenges to prepare for, new laws and rules to understand and interpret, new formats and frameworks to develop and implement! We love setting the bar high and enjoy pushing ourselves to work smarter! Our chat groups buzz with new things we spot; we step in for one another when needed, be it for exams, illness, marriage or relocation. We are honest and direct with empathy, be it giving a reason for taking leave or submitting bills or providing feedback. We ask colleagues to remind and follow up internally, and we celebrate the smallest of achievements!',
        'Most of our roles require a keen desire to find the core purpose of the NPOs we work with, a questioning mind that is eager to get to the root, a love for data and numbers, an eye for detail, an obsession with grammar, punctuations and formatting, a passion for stories that explain numbers, a flair for colour and design, presentations that speak aloud, delivered with humility in the language our audience understands, with the perfect diction and pronunciation! We care about savouring every step of the journey, with agility, making adjustments to carry everyone along to the next milestone!',
        'We pay as per Indian NPO benchmarks. We have an annual performance appraisal process leading to rewards and recognition. As you grow in the organisation with phenomenal opportunities for learning, exposure to addressing ecosystem challenges and a larger canvas to make a difference, the compensation also grows modestly, but the quality of your life and sense of fulfillment outpaces a corporate career!'
    ]

    const section3 = [
        'Age is no bar! Our team has bright eyed-fresh grads to a strict and sharp grandmom! Your academic background and nature of experience do not matter! Your academic and extracurricular achievements do matter, consistency in your previous jobs is important, demonstrated problem-solving capabilities at work/home/college/community tell us a lot about you, respect for systems and processes is critical, a willingness to adapt and adjust to a fast-paced environment would surely help! If life has thrown curve balls at you and you want to make a re-start, we are a great place to get going again!',
        'If you do not like spreadsheets, if you get easily bored, if you do not believe in notetaking and maintaining detailed checklists, please do not apply to us. We wish you the best to find a place that suits you.'
    ]

    const section4 = [
        'All our openings are at our Mumbai office, unless specified otherwise. All our work is from office…we are a bit old fashioned, we enjoy working together from the office! Most of our team members show up at office before time, every single day! ',
        'While most of the roles are deskbound, there are daily interactions with NPO leaders via phone, email and virtual meetings. We encourage team members to travel to conduct NPO workshops and participate in NPO visits and social sector events. We encourage travel and stay options that are safe and women & family friendly. '
    ]


    const points1 = [
        'Analysts for NPO Due Diligence' ,
        'Interns and Trainees (Graduates &amp; Post Graduates)',
        'MarComm Manager',
        'Training and Development Coordinator'
    ]

  return (
    <div className='max-w-screen overflow-hidden text-black'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                image={career}
                topic={"WORK WITH US"}
                header={'Careers at GuideStar India'}
                section={section1}
            />
            <FooterSecComp
                header={'What it is like to work at GuideStar India'}
                section={section2}
            />
            <FooterSecComp
                header={'Who should apply'}
                section={section3}
            />
            <FooterSecComp
                header={'Current Openings'}
                section={section4}
            />
            <FooterSecComp
                header={'Positions currently open'}
                pointHead={'Please click the below links to view Job Descriptions'}
            />
            {/* <FooterSecComp
                points={points1}
            /> */}
            <ul>
                <li className='list-disc ml-10'>
                    <a className='text-blue-600' rel='noreferrer' href="https://guidestarindia.frappe.cloud/files/Analysts-for-NPO-Due-Diligence.pdf" target='_blank'>Analysts for NPO Due Diligence</a>
                </li>
                <li className='list-disc ml-10'>
                    <a className='text-blue-600' rel='noreferrer' href="https://guidestarindia.frappe.cloud/files/Interns-and-Trainees.pdf" target='_blank'>Interns and Trainees (Graduates &amp; Post Graduates)</a>
                </li>
                <li className='list-disc ml-10'>
                    <a className='text-blue-600' rel='noreferrer' href="https://guidestarindia.frappe.cloud/files/MarComm-Manager.pdf" target='_blank'>MarComm Manager</a>
                </li>
                <li className='list-disc ml-10'>
                    <a className='text-blue-600' rel='noreferrer' href="https://guidestarindia.frappe.cloud/files/Training-and-Development-Coordinator.pdf" target='_blank'>Training Coordinator - Capacity Building for NPO Partners</a>
                </li>
            </ul>
            <FooterSecComp
                header={'How to apply'}
            />
            <Typography variant='h3'  sx={{fontSize:'15px' , fontWeight:400 , margin:' 0 0 10px 0' , textAlign:'justify' , lineHeight:1.6}}>
                Fill this application form  to tell us more about you!
            </Typography>
            <Typography variant='h3'  sx={{fontSize:'15px' , fontWeight:400 , margin:' 0 0 10px 0' , textAlign:'justify' , lineHeight:1.6}}>
                After you submit the application form, write an email to<a href="mailto:careers@guidestarindia.org" target="_blank" rel="noopener noreferrer" className='text-blue-600'> careers@guidestarindia.org </a> stating the <span className='font-bold'>role applied for</span>  in the subject line.
            </Typography>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf_NNcYqhUt4B3FBaklpHsG4yRRWYoEQx1dG7vGuizsaXzAZQ/viewform?embedded=true" width="640" height="8170" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            
        </div>
        <FooterComp/>
    </div>
  )
}

export default WorkWithUs